<template>
    <router-view></router-view>
</template>


<script>

  export default {
    data(){
      return {
        state: ''
      }
    },
    created(){
      this.state = 'siteList'
    }
  }
</script>